export const MINIMUM_ACCEPTED_CERTIFICATION_SCORE = 0.9
export const CERTIFICATION_RECORDING_DELETION_DELAY_DAYS = 14

export const MINIMUM_SAT_MATH_SCORE = '700'
export const MINIMUM_SAT_READING_SCORE = '700'

export const GOAL_CERTIFICATION_TEAM_REVIEW_DAYS = 2
